const minsAgo = (m) => new Date(Date.now() - m * 60 * 1000).toISOString();
const PHONE_NUMBER_ID = "109876543210987";

let msgSeq = 1;
const msg = (ConversationId, o) => {
  const id = msgSeq++;
  const createdAt = minsAgo(o.ago);
  return {
    id,
    ConversationId,
    whatsappMessageId: `wamid.MOCK${String(id).padStart(6, "0")}`,
    direction: o.direction,
    contentType: o.contentType || "text",
    content: o.content,
    status: o.status || (o.direction === "outbound" ? "delivered" : "read"),
    status_status: o.status_status ?? null,
    order_id: o.order_id ?? null,
    orderNumber: o.orderNumber ?? null,
    order_total: o.order_total ?? null,
    order_status: o.order_status || "pending",
    mediaUrl: o.mediaUrl ?? null,
    rawData: null,
    errorRaw: o.errorRaw ?? null,
    createdAt,
    updatedAt: createdAt,
  };
};

const conv = (id, customerNumber, unreadCount, messages) => {
  const last = messages[messages.length - 1];
  return {
    id,
    workspace_id: 1,
    store_id: 37381,
    phoneNumberId: PHONE_NUMBER_ID,
    customerNumber,
    status: "active",
    lastMessageAt: last.createdAt,
    unreadCount,
    createdAt: messages[0].createdAt,
    updatedAt: last.createdAt,
    Messages: messages, // oldest first
  };
};

const build = () => {
  msgSeq = 1;
  const list = [
    conv(1, "923001234567", 2, [
      msg(1, {
        direction: "outbound",
        ago: 190,
        contentType: "order",
        content:
          "Order #VN-1042 confirmation: Rs. 4,500. Reply YES to confirm.",
        order_id: "7001",
        orderNumber: "VN-1042",
        order_total: 4500,
        order_status: "pending",
      }),
      msg(1, { direction: "inbound", ago: 185, content: "YES" }),
      msg(1, {
        direction: "outbound",
        ago: 184,
        content:
          "Thank you! Your order is confirmed and will ship within 2 days.",
      }),
      msg(1, {
        direction: "inbound",
        ago: 6,
        content: "When will it reach Lahore?",
      }),
      msg(1, {
        direction: "inbound",
        ago: 5,
        content: "Please share the tracking number",
      }),
    ]),
    conv(2, "923214567890", 0, [
      msg(2, {
        direction: "outbound",
        ago: 1500,
        contentType: "order",
        content:
          "Order #VN-1039 confirmation: Rs. 2,990. Reply YES to confirm.",
        order_id: "6998",
        orderNumber: "VN-1039",
        order_total: 2990,
        order_status: "confirmed",
      }),
      msg(2, { direction: "inbound", ago: 1490, content: "yes confirm" }),
      msg(2, {
        direction: "outbound",
        ago: 60,
        status: "read",
        content: "Your order has been dispatched via TCS. Tracking: 778812345.",
      }),
      msg(2, { direction: "inbound", ago: 45, content: "Received, thanks" }),
    ]),
    conv(3, "923331112233", 1, [
      msg(3, {
        direction: "inbound",
        ago: 40,
        contentType: "image",
        content: "Is this the same color?",
        mediaUrl: "https://picsum.photos/seed/vn1/400/300",
      }),
    ]),
    conv(4, "923457778899", 0, [
      msg(4, {
        direction: "outbound",
        ago: 2900,
        contentType: "order",
        content:
          "Order #VN-1031 confirmation: Rs. 7,200. Reply YES to confirm.",
        order_id: "6987",
        orderNumber: "VN-1031",
        order_total: 7200,
        order_status: "canceled",
      }),
      msg(4, {
        direction: "inbound",
        ago: 2880,
        content: "Cancel it please, wrong address",
      }),
      msg(4, {
        direction: "outbound",
        ago: 2870,
        status: "read",
        content: "Done, your order has been canceled.",
      }),
    ]),
    conv(5, "923009998877", 0, [
      msg(5, {
        direction: "outbound",
        ago: 4400,
        status: "failed",
        content: "Hi! Your order #VN-1020 is out for delivery.",
        errorRaw: JSON.stringify({
          code: 131047,
          message: "Re-engagement message: 24h window closed",
        }),
      }),
    ]),
    conv(6, "923121234000", 0, [
      msg(6, {
        direction: "inbound",
        ago: 6000,
        contentType: "audio",
        content: "Voice message",
        mediaUrl: "https://example.com/mock.ogg",
      }),
      msg(6, {
        direction: "outbound",
        ago: 5990,
        status: "read",
        content:
          "Sorry, we can't play voice notes here. Could you type your question?",
      }),
    ]),
    conv(7, "923441239876", 0, [
      msg(7, {
        direction: "outbound",
        ago: 9000,
        contentType: "document",
        content: "Invoice VN-1002.pdf",
        mediaUrl: "https://example.com/invoice.pdf",
        status: "read",
      }),
    ]),
  ];

  // pad with extra conversations to test pagination
  for (let i = 8; i <= 60; i++) {
    list.push(
      conv(
        i,
        `92300${String(1000000 + i * 137).slice(0, 7)}`,
        i % 5 === 0 ? 1 : 0,
        [
          msg(i, {
            direction: "inbound",
            ago: 10000 + i * 90,
            content: `Hello, question about order #${2000 + i}`,
          }),
          msg(i, {
            direction: "outbound",
            ago: 9990 + i * 90,
            content: "Sure, how can we help?",
          }),
        ],
      ),
    );
  }
  // newest first, like lastMessageAt DESC
  return list.sort(
    (a, b) => new Date(b.lastMessageAt) - new Date(a.lastMessageAt),
  );
};

const DB = build();
const wait = (ms = 400) => new Promise((r) => setTimeout(r, ms));

const paginate = (rows, page, limit) => {
  const total = rows.length;
  const totalPages = Math.max(1, Math.ceil(total / limit));
  const start = (page - 1) * limit;
  return {
    chats: rows.slice(start, start + limit),
    total,
    totalPages,
    hasMore: page < totalPages,
  };
};

export const mockGetConversations = async (page = 1, limit = 50) => {
  await wait();
  // the list doesn't need full message history, so send only the last message
  const rows = DB.map((c) => ({ ...c, Messages: c.Messages.slice(-1) }));
  return paginate(rows, page, limit);
};

export const mockSearchConversations = async (search) => {
  await wait(250);
  const rows = DB.filter((c) => c.customerNumber.includes(search.trim())).map(
    (c) => ({ ...c, Messages: c.Messages.slice(-1) }),
  );
  return paginate(rows, 1, 50);
};

export const mockGetMessages = async (conversationId) => {
  await wait(300);
  return DB.find((c) => c.id === conversationId)?.Messages ?? [];
};
